<template>
  <div class="card">
    <h2 class="project-name text-bold">
      {{ orderInfo.orderName }}
    </h2>

    <invite-bid-info :invite-bid-form="orderInfo">
      <div slot="title">
        <slot></slot>
      </div>
    </invite-bid-info>

    <div class="section">
      <div class="section-title">
        <base-section-title
          :title="
            orderInfo.releaseMethod === bidPublishWayDict.NOTICE_BIDDING.value
              ? '公告内容'
              : '邀请函'
          "
        />
      </div>
      <div class="section-content notice-content">
        <h4>{{ orderInfo.title }}</h4>
        <u-editor disabled :value="orderInfo.content" />
      </div>
    </div>
  </div>
</template>

<script>
// 全局组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'

// 模块组件
import InviteBidInfo from '@/views/supplier-views/purchase/components/InviteBidInfo/InviteBidInfo'

import { bidPublishWayDict } from '@/dictionary/project/bid'

export default {
  name: 'SupplierPurchaseInfo',

  components: {
    BaseSectionTitle,
    UEditor,
    InviteBidInfo
  },

  props: {
    orderId: {
      type: Number,
      default: 0
    },

    orderInfo: {
      type: Object,
      default: () => {}
    },

    title: {
      type: String,
      default: '招标公告'
    }
  },

  data() {
    return {
      bidPublishWayDict
    }
  },

  computed: {
    // 招标单名称
    orderName() {
      return this.orderInfo.orderName
    }
  }
}
</script>

<style lang="scss" scoped>
.file-section {
  width: 500px;
}

.project-name {
  text-align: center;
  font-size: pixel-to-rem($n: 26);
  line-height: 1.5;
  padding: pixel-to-rem(20);
  padding-top: 0;
  border-bottom: 1px solid $border-color;
  margin-bottom: pixel-to-rem($n: 20);
}

// 公告内容样式
.notice-content {
  h4 {
    font-size: pixel-to-rem($n: 20);
  }
}
</style>
